// extracted by mini-css-extract-plugin
module.exports = {"cont-education":"cont-education","contEducation":"cont-education"};